'use client';
import React from 'react';

type ScrollButtonContextType = {
  isAccordionExpanded: boolean;
  setIsAccordionExpanded: (expanded: boolean) => void;
};

const ScrollButtonContext = React.createContext<ScrollButtonContextType | undefined>(undefined);

export function ScrollButtonProvider({ children }: { children: React.ReactNode }) {
  const [isAccordionExpanded, setIsAccordionExpanded] = React.useState(false);

  return (
    <ScrollButtonContext.Provider value={{ isAccordionExpanded, setIsAccordionExpanded }}>
      {children}
    </ScrollButtonContext.Provider>
  );
}

export function useScrollButton() {
  const context = React.useContext(ScrollButtonContext);
  if (context === undefined) {
    throw new Error('useScrollButton must be used within a ScrollButtonProvider');
  }
  return context;
}
